import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import HorizontalSlider from '../HorizontalSlider';
import InventoryProvider from '../InventoryProvider';
import ProductListViewItem from '../ProductListViewItem';
import Skeleton from '../Skeleton';
import { searchProductswithimagekey } from '~graphql/custom_queries';
import { getRecentlyViewedProducts } from '~graphql/queries';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import { Product } from '~types/api';
import { useGraphql } from '~view/hooks/graphql';

const RecentlyViewedProducts: React.FC = () => {
  const user = useSelector(authUserSelector);
  const [productIds, fetchIds, loading] = useGraphql(
    getRecentlyViewedProducts,
    (data) => {
      return data.getRecentlyViewedProducts;
    }
  );
  const [items, fetchProducts, searching] = useGraphql(
    searchProductswithimagekey,
    (data) => {
      return data.searchProducts.items;
    }
  );
  const products = useMemo<Product[]>(() => {
    if (!productIds?.length || !items?.length) {
      return [];
    }
    return productIds
      .map((id: string) => items.find((item: any) => item.id === id))
      .filter((item: any) => item);
  }, [productIds, items]);

  useEffect(() => {
    if (!user) return;
    fetchIds({ userId: user.attributes.sub });
  }, [user]);

  useEffect(() => {
    if (!productIds?.length) return;
    fetchProducts({
      filter: { or: productIds.map((id: string) => ({ id: { eq: id } })) },
    });
  }, [productIds]);

  if (loading || searching) {
    return (
      <div>
        <div className="mb-4">
          <Skeleton height={30} width={200} />
        </div>
        <HorizontalSlider xs={2}>
          {[...new Array(10)].map((_, i) => (
            <ProductListViewItem key={i} col={false} border />
          ))}
        </HorizontalSlider>
      </div>
    );
  }

  if (!products.length) {
    return null;
  }

  return (
    <InventoryProvider productIds={products.map((product) => product.id!)}>
      <div>
        <h5 className="font-weight-bold mb-4">チェックした商品</h5>
      </div>
      <HorizontalSlider xs={2}>
        {products.map((product, i) => (
          <ProductListViewItem
            key={product.id}
            product={product}
            productTypes={product.producttype?.items}
            index={i}
            col={false}
            border
          />
        ))}
      </HorizontalSlider>
    </InventoryProvider>
  );
};

export default RecentlyViewedProducts;
